import "./TestIcdCodesViewEditComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import TestIcdCodesEditComponent from "./test-icd-codes-edit/TestIcdCodesEditComponent";
import TestIcdCodesViewComponent from "./test-icd-codes-view/TestIcdCodesViewComponent";

interface TestIcdCodesViewEditComponentProps {
    testDetails: any
    onUpdateInformation: Function;
    onModeChange: Function;
    canEdit: boolean;
}

const TestIcdCodesViewEditComponent = (props: TestIcdCodesViewEditComponentProps) => {

    const {testDetails, onUpdateInformation, onModeChange, canEdit} = props;
    const [mode, setMode] = useState<"view" | "edit">("view");
    const [testBasicInformation, setTestBasicInformation] = useState<any>(undefined);

    const handleTestInformationUpdate = useCallback((updatedTestInformation: any, redirectTabId?: "basic_details" | "attachments" | "configuration" | "assigned_labs" | "report_type") => {
        onUpdateInformation(updatedTestInformation, redirectTabId);
        setMode("view");
    }, [onUpdateInformation]);

    const handlePanelInformationEditCancel = useCallback(() => {
        setMode("view");
    }, []);

    useEffect(() => {
        if (testDetails) {
            setTestBasicInformation(testDetails);
        }
    }, [testDetails]);

    useEffect(() => {
        onModeChange(mode)
    }, [mode, onModeChange])

    return (
        <div className={'test-icd-codes-view-edit-component  details-tab-data-wrapper'}>
            {
                mode === "view" && <TestIcdCodesViewComponent testDetails={testBasicInformation} canEdit={canEdit}
                                                             onEditModeOpen={() => {
                                                                 setMode("edit")
                                                             }}
                />
            }
            {
                mode === "edit" && <TestIcdCodesEditComponent
                    testDetails={testBasicInformation}
                    onUpdateComplete={handleTestInformationUpdate}
                    onEditCancel={handlePanelInformationEditCancel}
                />
            }
        </div>
    );

};

export default TestIcdCodesViewEditComponent;